import '@/assets/style/companyList.scss';
import { useTransactionContext } from '@/context/TransactionContext';
import GlobalDivider from '@/utils/divider/GlobalDivider';
import {
  CalculatePercentageValue,
  calculateSecondForm,
  handleFieldChange,
  handleGrossWeightToTola,
  handleNewRowData,
  handlePurity,
  thirdFormBoxCalculation,
} from '@/utils/formula/CodeWindow';

import { ShowAllData } from '@/apiError/apiShow';
import DynamicCodeWIndowForm from '@/pages/reports/reuse/DynamicCodeWIndowForm';
import { generateNewRowData } from '@/pages/transaction/reuse/DynamicTransactionFunctions';
import { VoucherFooterButton } from '@/pages/vouchers/VoucherComponent';
import {
  CalculatePercentageValueofSalesModal,
  handleSalesDescription,
  wastageTypeSalesModalCalculataion,
} from '@/utils/formula/SalesDescription';
import LoadingOverlay from '@/utils/loading/loadingOverlay';
// import { Back } from '@/utils/routerPath/NavigationHelper';
import SalesDescriptionModal from '@/utils/transaction/modal/SalesDescriptionModal';
import UtilCodeWindowTable from '@/utils/transaction/table/UtilCodeWindowTable';
import {
  rotateTabWithinForm,
  useInputRef,
} from '@/utils/validation/FormValidation';
import { Button, Divider, Form, Modal } from 'antd';
import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { showToast } from '@/utils/toastMessage/ToastMessage';
import Cookies from 'js-cookie';
import GlobalFormModal from '@/utils/modal/GlobalFormModal';
import TodayGoldRate from '@/pages/master/todayGoldRate/TodayGoldRate';
import { AntButton } from '@/common/ant-components/AntButton';
import { ModalFooterButton } from './footerButtons';
import useAppData from '@/hooks/useAppData';
// import { focusNode } from '@/pages/reports/reuse/helpers';

/**
 * CodeWindow component for managing purchase details and stone/diamond entries.
 * @returns {JSX.Element} CodeWindow component.
 */
const SalesQuotationWindow = () => {
  const {
    globalDividerTitle,
    previousPath,
    onSalesOrderTableDataChange,
    salesOrderTableData,
    setSalesOrderTableData,
    prefixResponse,
    tableData,
    setTableData,
    totalPcsDiamond,
    setSelectedItems,
    totalPcsStone,
    setPrefixResponse,
    totalDiamondWeight,
    totalStoneWeight,
    totalDiamondAmount,
    totalGramLalValue,
    totalStoneAmount,
    setEditApiBlock,
    showSalesDescription,
    setShowSalesDescription,
    isModalVisible,
    setIsModalVisible,
    record,
    open,
    setOpen,
    isCancel,
    setHiddenValueChange,
    setIsCancel,
  } = useTransactionContext();
  const { firstInputRef, lastInputRef } = useInputRef();
  const { id } = useParams();
  const navigate = useNavigate();
  const [form] = Form.useForm();

  const [openDsT, setopenDsT] = useState(false);

  const newRowData = salesOrderTableData?.find(
    (rowData) => (rowData?.codeWindowId || rowData.id) === id,
  );

  const itemName = newRowData?.itemName;
  const itemCode = newRowData?.code || newRowData?.itemCode;
  const imageUrl = newRowData?.images;

  const [loading, setLoading] = useState();
  const [fileList, setFileList] = useState([]);
  const [showTodayGoldRate, setShowTodayGoldRate] = useState(false);
  const primaryCalculationType = Cookies.get('primaryCalculationType');
  const primaryWeight = Cookies.get('primaryWeight');

  const [formData, setFormData] = useState({
    referenceItemCode: '',
    size: '',
    purity: 100,
    crt: 24,
    percent: 100,
    makingCharge: 0,
    makingChargeType: 'amount',
    makingAmount: 0,
    wastageType: 'w',
    wastageWeight: 0,
    grossWeight: '',
    grossWeightGm: 0,
    rate: 0,
    wastageCharge: 0,
    setPcs: 1,
    extraAmount: 0,
    diamondWeightGram: 0,
    stoneWeightGram: 0,
    diamondAmount: 0,
    stoneAmount: 0,
    netWeight: 0,
    fixedAmount: 'no',
    netAmount: 0,
    netWithWastage: 0,
    pureWeight: 0,
    diamondPcs: 0,
    diamondWeightCrt: 0,
    stoneWeightCrt: 0,
    metalAmount: 0,
    itemId: '',
    itemType: '',
    sMakingChargeType: 'amount',
    sMakingCharge: 0,
    sMakingAmount: 0,
    sWastageType: 'w',
    sWastageCharge: 0,
    sWastageWeight: 0,
    sFixedAmount: 'no',
    sNetAmount: 0,
    description: '',
  });

  // const showSalesIncomingRate = ['sales/create', 'sales/edit'].some((route) =>
  //   location.pathname.includes(route),
  // );

  const handleFormKeyDown = (e) => {
    rotateTabWithinForm(e, firstInputRef, lastInputRef);
  };

  const onCalculateSecondForm = () => {
    calculateSecondForm(form, formData, setFormData, primaryCalculationType);
  };
  const onFieldChange = (fieldName, value) => {
    handleFieldChange(form, fieldName, value, formData, setFormData);
    handleGrossWeightToTola(fieldName, value, formData, form, setFormData);
  };

  const onPurityChange = (fieldName, value) => {
    handlePurity(fieldName, value, formData, setFormData, form);
  };

  const onCalculatePercentage = () => {
    CalculatePercentageValue(form, formData, setFormData);
  };

  const onThirdFormBoxCalculation = () => {
    thirdFormBoxCalculation(form, formData, setFormData);
  };

  useEffect(() => {
    onCalculateSecondForm();
  }, [
    form.getFieldValue('makingAmount'),
    form.getFieldValue('grossWeight'),
    form.getFieldValue('grossWeightGm'),
    form.getFieldValue('diamondWeightGram'),
    form.getFieldValue('stoneWeightGram'),
    form.getFieldValue('rate'),
    form.getFieldValue('extraAmount'),
    form.getFieldValue('wastageWeight'),
    form.getFieldValue('wastageCharge'),
    form.getFieldValue('wastageType'),
    form.getFieldValue('crt'),
    form.getFieldValue('diamondAmount'),
    form.getFieldValue('stoneAmount'),
    form.getFieldValue('purity'),
    formData?.purity,
    formData?.crt,
    form.getFieldValue('makingCharge'),
    form.getFieldValue('makingChargeType'),
    form.getFieldValue('setPcs'),
    form.getFieldValue('fixedAmount'),
  ]);
  useEffect(() => {
    onThirdFormBoxCalculation();
  }, [
    form.getFieldValue('wastageType'),
    form.getFieldValue('wastageCharge'),
    form.getFieldValue('pureWeight'),
    form.getFieldValue('netWeight'),
    form.getFieldValue('grossWeight'),
  ]);
  useEffect(() => {
    onCalculatePercentage();
  }, [
    form.getFieldValue('grossWeight'),
    form.getFieldValue('rate'),
    form.getFieldValue('makingCharge'),
    form.getFieldValue('makingChargeType'),
  ]);

  useEffect(() => {
    const showTableDataChange = () => {
      form.setFieldsValue({
        diamondPcs: totalPcsDiamond,
        stonePcs: totalPcsStone,
        stoneWeightCrt: totalStoneWeight,
        stoneWeightGram:
          primaryCalculationType === 'lal'
            ? Number(totalGramLalValue).toFixed(1)
            : Number(totalGramLalValue).toFixed(3),

        diamondWeightCrt: totalDiamondWeight,
        diamondWeightGram:
          primaryCalculationType === 'lal'
            ? parseFloat(totalDiamondWeight * primaryWeight).toFixed(1)
            : (totalDiamondWeight / 5).toFixed(3),
        diamondAmount: totalDiamondAmount.toLocaleString(),
        stoneAmount: totalStoneAmount.toLocaleString(),
      });

      setFormData({
        ...formData,
        diamondPcs: Number(totalPcsDiamond),
        stonePcs: Number(totalPcsStone),
        stoneWeightCrt: Number(totalStoneWeight),
        stoneWeightGram:
          primaryCalculationType === 'lal'
            ? Number(totalGramLalValue).toFixed(1)
            : Number(totalGramLalValue).toFixed(3), // primaryCalculationType === 'lal'

        diamondWeightCrt: Number(totalDiamondWeight),
        diamondWeightGram:
          primaryCalculationType === 'lal'
            ? (totalDiamondWeight * primaryWeight).toFixed(3)
            : (totalDiamondWeight / 5).toFixed(3),
        diamondAmount: Number(totalDiamondAmount),
        stoneAmount: Number(totalStoneAmount),
      });
    };
    showTableDataChange();
  }, [
    tableData,
    totalPcsDiamond,
    totalPcsStone,
    totalDiamondWeight,
    totalStoneWeight,
    totalDiamondAmount,
    totalStoneAmount,
  ]);
  useEffect(() => {
    if (
      prefixResponse?.itemType === 'Gold' ||
      prefixResponse?.itemType === 'Silver'
    ) {
      getGoldRate();
    }
    form.setFieldsValue({
      ...prefixResponse,
    });
    setFormData((prev) => ({
      ...prev,
      wastageType: prefixResponse?.wastageType || 'w',
      wastageWeight: prefixResponse?.wastageWeight || 0,
      makingChargeType: prefixResponse?.makingChargeType || 'amount',
      makingCharge: prefixResponse?.makingCharge || 0,
      makingAmount: prefixResponse?.makingAmount || 0,
      wastageCharge: prefixResponse?.wastageCharge || 0,
      itemType: prefixResponse?.itemType || '',
    }));
  }, [prefixResponse]);

  const getGoldRate = async () => {
    const data = await ShowAllData.showDetails('transaction/gold-rates/');

    if (
      data?.data?.goldRate &&
      !isNaN(data.data.goldRate.goldRate) > 0 &&
      Number(data.data.goldRate.goldRate) > 0
    ) {
      let rate = data?.data?.goldRate;
      const newRate =
        prefixResponse?.itemType === 'Gold'
          ? rate?.goldRate
          : prefixResponse?.itemType === 'Silver'
            ? rate?.silverRate
            : 0;
      form.setFieldsValue({ rate: newRate });
      setFormData((prev) => ({
        ...prev,
        rate: newRate,
      }));
    } else {
      form.setFieldsValue({ rate: 0 }); // Reset to 0 if no data
      setFormData((prev) => ({
        ...prev,
        rate: 0,
      }));

      toast.warn(
        <span
          onClick={() => setShowTodayGoldRate(true)}
          style={{ cursor: 'pointer' }}
        >
          Click here to update the gold rate page for the latest{' '}
          {prefixResponse?.itemType} rate
        </span>,
        {
          position: 'top-right',
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          style: { backgroundColor: '#f1c40f', color: '#fff' }, // Custom warning color (optional)
        },
      );
    }
  };
  const onHandleSalesDescription = (fieldName, value) => {
    handleSalesDescription(form, fieldName, value, formData, setFormData);
  };

  useEffect(() => {
    CalculatePercentageValueofSalesModal(form, formData, setFormData);
  }, [formData?.grossWeight, formData?.rate, formData.sMakingCharge]);

  useEffect(() => {
    wastageTypeSalesModalCalculataion(form, formData, setFormData);
  }, [
    formData?.grossWeight,
    formData?.netWeight,
    formData?.pureWeight,
    formData.sWastageType,
    formData.sWastageCharge,
  ]);

  useEffect(() => {
    if (newRowData?.codeWindowId) {
      setFormData((prev) => ({ ...prev, ...newRowData }));
      form.setFieldsValue(newRowData);
    }
  }, [newRowData?.codeWindowId, form]);

  useEffect(() => {
    setEditApiBlock(true);
    // if (imageUrl !== undefined && imageUrl !== null && imageUrl !== '') {
    //   const fileObj = {
    //     uid: itemCode, // Unique identifier
    //     name: itemName, // Default name
    //     status: 'done',
    //     url: imageUrl, // Image URL
    //   };
    //   setFileList([fileObj]); // Set the file list when imageUrl exists
    // }

    if (imageUrl?.length > 0) {
      const newList = imageUrl?.map((image, index) => ({
        uid: `${image?.id || index}`, // Ensure each image gets a unique UID
        id: image?.id,
        // Unique identifier
        name: itemName + id, // Default name
        status: 'done',
        url: image?.image, // Image URL
      }));
      setFileList(newList);
    }
  }, [itemName, imageUrl]);

  useEffect(() => {
    if (newRowData?.codeWindowId) {
      handleGrossWeightToTola(
        'grossWeight',
        newRowData?.grossWeight,
        formData,
        form,
        setFormData,
      );
      handlePurity('purity', newRowData?.purity, formData, setFormData, form);
    }
  }, []);

  const { app } = useAppData();

  const createPurchase = async (value) => {
    await form.validateFields();
    const netWeight = form.getFieldValue('netWeight');
    const rate = form.getFieldValue('rate');

    if (netWeight < 0) {
      form.getFieldInstance('netWeight')?.focus();
      showToast('Transaction data cannot be negative', 'error');
      return;
    }
    if (rate <= 0) {
      form.getFieldInstance('rate')?.focus();
      showToast('Rate cannot be zero', 'error');
      form.getFieldInstance('rate')?.focus();
      return;
    }
    const isEmptyTableData = tableData?.every((item) => {
      for (const key in item) {
        if (
          key !== 'key' &&
          key !== 'unit' &&
          key !== 'disabledUnit' &&
          key !== 'amount' &&
          item[key] !== ''
        ) {
          return false;
        }
      }
      return true;
    });

    let newRowData = salesOrderTableData?.find(
      (rowData) => (rowData?.id || rowData?.codeWindowId) === id,
    );

    const netAmount = form.getFieldValue('netAmount');
    const photo = formData?.fileList?.length
      ? formData?.fileList
      : formData?.images;

    const itemType = newRowData?.itemType || newRowData?.itemTypeName;

    const finalData = {
      detailsJson: [
        {
          ...formData,
          netAmount: netAmount,
          itemId:
            newRowData?.itemId ||
            newRowData?.item ||
            newRowData?.finalData?.detailsJson[0]?.itemId,
          images: photo,
        },
      ],

      diamondStoneJson: isEmptyTableData ? [] : tableData,
    };

    newRowData = generateNewRowData(
      form,
      formData,
      newRowData,
      finalData,
      primaryCalculationType,
    );

    setHiddenValueChange(true);

    onSalesOrderTableDataChange({
      ...newRowData,
      taxPercent:
        itemType && itemType?.toLowerCase() !== 'silver'
          ? Number(app?.luxuryTaxPercent || 0) / 100 || 0
          : itemType?.toLowerCase() === 'silver' &&
              Number(netAmount) > Number(app?.silverThresholdAmount || 0)
            ? Number(app?.luxuryTaxPercent || 0) / 100 || 0
            : 0,
      vatPercent:
        isEmptyTableData || !app?.isVatApplicable
          ? 0
          : Number(app?.vatPercent || 0) / 100 || 0,
    });

    form.resetFields();
    setFileList([]);
    setShowSalesDescription(true);
    setPrefixResponse({});
    navigate(previousPath);
    setTableData([
      {
        key: '1',
        typeId: '',
        rateOn: '',
        pcs: '',
        unit: '',
        weight: '',
        purchaseRate: '',
        salesRate: '',
        hc: '',
        color: '',
        clarity: '',
        cut: '',
        amount: '',
        remark: '',
        isName: '',
        itemTypeId: '',
        itemTypeName: '',
        disabledUnit: false,
      },
    ]);
  };

  useEffect(() => {
    handleNewRowData(newRowData, form, setFormData, setTableData);
  }, [newRowData, form]);

  const handleKey = (e) => {
    if (e.code === 'F3') {
      e.preventDefault();
      setIsModalVisible(true);
    } else if (e.code === 'F5') {
      e.preventDefault();
      setopenDsT(true);
    } else if (e.code === 'F10') {
      e.preventDefault();
      form
        .validateFields()
        .then(() => {
          setIsCancel('not-cancel');
          form.submit();
        })
        .catch((errorInfo) => {
          const firstErrorField = errorInfo.errorFields[0]?.name?.[0];
          if (firstErrorField) {
            form.getFieldInstance(firstErrorField)?.focus();
          }
        });
    } else if (e.code === 'F12') {
      e.preventDefault();
      setIsCancel('not-cancel');
    }
  };

  useEffect(() => {
    window.addEventListener('keydown', handleKey);
    return () => {
      window.removeEventListener('keydown', handleKey);
    };
  }, []);

  const handleModalClose = () => {
    setIsCancel('cancel');
    const filteredData = salesOrderTableData?.filter(
      (item) => item?.item !== record?.value,
    );
    setSalesOrderTableData(filteredData);
    setSelectedItems((prevData) =>
      prevData.filter((id) => id !== record?.value),
    );
  };

  return (
    <Modal
      open={true}
      placement="right"
      width={'90%'}
      onCancel={() => {
        handleModalClose();
        navigate(-1);
      }}
      title={<div>{globalDividerTitle}</div>}
      footer={null}
    >
      <div>
        <LoadingOverlay loading={loading} />
        <Form
          initialValues={formData}
          layout="vertical"
          form={form}
          onFinish={createPurchase}
          scrollToFirstError={{
            focus: true,
          }}
          onFinishFailed={({ errorFields }) => {
            const firstErrorField = errorFields[0];
            const fieldName = firstErrorField.name?.[0];
            form?.getFieldInstance(fieldName)?.focus();
          }}
          style={{
            maxWidth: 'none',
            // background: token.colorFillAlter,
            // borderRadius: token.borderRadiusLG,
            // padding: 20,
          }}
          onKeyDown={handleFormKeyDown}
        >
          <Divider
            dashed
            orientation="left"
            style={{
              fontStyle: 'italic',
              fontWeight: '600',
              color: 'green',
              margin: '0 0 10px 0',
              padding: 0,
            }}
          >
            Item: {itemName} &nbsp;&nbsp;&nbsp;&nbsp;Code: {itemCode}
          </Divider>
          <DynamicCodeWIndowForm
            loading={loading}
            handleKeyDown={handleFormKeyDown}
            firstInputRef={firstInputRef}
            formData={formData}
            onFieldChange={onFieldChange}
            onPurityChange={onPurityChange}
            form={form}
            setFormData={setFormData}
            primaryCalculationType={primaryCalculationType}
            fileList={fileList}
            itemName={itemName}
          />
          <Divider
            style={{
              margin: '4px',
            }}
          />
          <div className="tw-flex tw-justify-between ">
            <div className="tw-flex tw-gap-x-2">
              <div>
                {showSalesDescription && (
                  <div>
                    <Button onClick={() => setIsModalVisible(true)}>
                      Add Sales Description [F3]
                    </Button>
                  </div>
                )}
              </div>
              <div>
                <AntButton color="lightGreen" onClick={() => setopenDsT(true)}>
                  Add Diamond/Stone Table [F5]
                </AntButton>
              </div>
            </div>

            <div>
              <ModalFooterButton
                id={id}
                path={previousPath}
                setIsCancel={setIsCancel}
                handleModalClose={handleModalClose}
              />
            </div>
          </div>

          <div>
            <SalesDescriptionModal
              isModalVisible={isModalVisible}
              setIsModalVisible={setIsModalVisible}
              onHandleSalesDescription={onHandleSalesDescription}
              formData={formData}
              form={form}
              setFormData={setFormData}
            />

            <>
              <div className="tw-mb-3">
                <UtilCodeWindowTable
                  formData={formData}
                  openDsT={openDsT}
                  setopenDsT={setopenDsT}
                  setFormData={setFormData}
                  primaryWeight={primaryWeight}
                  primaryCalculationType={primaryCalculationType}
                />
              </div>
            </>
          </div>
          <GlobalFormModal
            isVisible={showTodayGoldRate}
            onClose={() => setShowTodayGoldRate(false)}
          >
            <TodayGoldRate
              refreshTable={getGoldRate}
              onClose={() => setShowTodayGoldRate(false)}
              fromTransaction={true}
            />
          </GlobalFormModal>
        </Form>
      </div>
    </Modal>
  );
};

export default SalesQuotationWindow;
